<template>
  <div style="background-color:#f4f5f5; height:auto; padding-bottom: 120px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="onClickLeft">
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">購物車</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 130px; border-radius: 0% 0% 50% 50%;">
      <div style="margin-left:15px; display: inline-flex">
      </div>
    </div>
    <van-cell-group style="border-radius:10px; margin-top:-100px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" :border="false">
        <template>
          <span class="Details-title">商品清單</span>
          <van-empty
            v-if="list.length === 0"
            class="custom-image"
            image="/static/icon_cart_empty.svg"
            description="購物車空啦~"
          />
          <van-cell v-for="(item,index) in list" :key="index" style=" min-height: 100px; background-color: #f5f5f5f8; margin-top: 10px;">
            <template #icon>
              <van-image style="position: relative; left: -10px; width:70px; height: 70px;"  :src="item.itemImg"/>
            </template>
            <template #title>
              <div style="height:30px; display:inline-flex;">
                <span style="position: relative; top: -10px; font-size: 14px;"> {{ item.itemTitle }}</span>
                <van-icon  style="position:absolute; right:5px; float:right; top: 5px;" size="22px" name="delete-o" color="red" @click="onDelete(index,item.uid)"/>
              </div>
            </template>
            <template #label>
              <div style="position: relative; top: -15px; text-align:left;">
                <van-collapse v-model="activeNames"  :border="false">
                  <van-collapse-item :name="item.uid" style="border-radius:50px;">
                    <template #title>
                      <span style="font-size: 11px; margin-left: -15px;"> {{ item.packName }}</span>
                    </template>
                    <template>
                      <span style="font-size: 11px;"> {{ item.specsContent }}</span>
                    </template>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </template>
            <template #right-icon>
              <span style="position:absolute; text-align: right; right: 10px; bottom: 0px; font-weight: 700; color: rgb(53, 120, 229)"> {{ item.currency }}$ {{ item.price }}</span>
            </template>
          </van-cell>
      </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:10px; margin-left:20px; margin-right:20px; margin-bottom: 10px; margin-top:5px" :border="false">
      <van-cell style=" height: 50px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:absolute; text-align: right; right: 10px; top: 5px;"> 共計<span style="color: rgb(53, 120, 229); font-weight:700;">{{list.length}}</span>件商品</span>
        </template>
        <template #right-icon>
          <span style="position:absolute; text-align: right; right: 10px; top: 25px;"> 總價：<span style="color: rgb(53, 120, 229); font-weight:700;">NT$ {{price}}</span></span>
        </template>
      </van-cell>
    </van-cell-group>
    <van-divider>爲您推介</van-divider>
    <van-cell-group style="border-radius:20px; margin-top:20px; margin-left:7px; margin-right:7px;" :border="false">
      <van-cell style="margin-top:5px; border-radius:20px;" :border="false" size="large" >
        <template>
          <span class="Details-title"><van-icon name="fire-o" />好物推介</span>
        </template>
      </van-cell>
      <van-cell class="recomm-cell" :border="false" size="large">
        <van-grid :column-num="2" clickable :border="false" >
          <van-grid-item v-for="(item,index) in recomm" :key="index" @click="gotoItem(item.ShortLink)">
            <div style="width:100%; height: 10rem;">
              <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
            </div>
            <div style="height:40px; display:inline">
              <p style="float:left;  font-size:0.5rem;font-weight:900; line-height: 0.6rem; ">{{ item.ItemTitle }}</p>
            </div>
            <div style="width:100%;height:20px;">
              <span style="float:left; font-size:0.7rem; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
              <span style="float:right; font-size:0.7rem;color: gray;">售出：{{ item.sales }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
    <van-submit-bar
      class="action-bar"
      :decimal-length="0"
      label="合計："
      currency="NT$"
      safe-area-inset-bottom
      :price="price * 100"
    >
      <template #button>
        <van-button class="action-button" :disabled="list.length == 0" round type="info" @click="onSubmit">提交訂單</van-button>
      </template>
    </van-submit-bar>
  </div>
</template>
<script>
import { Toast, Notify, Dialog } from 'vant'
import { getItemRecommend } from '@/api/item'

export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      list: [],
      price: 0,
      recomm: [],
      activeNames: ['1']
    }
  },
  created () {
    this.getRecommendInfo()
    this.list = JSON.parse(sessionStorage.getItem('cart'))
    if (!this.list) {
      this.list = []
    } else {
      this.list = JSON.parse(sessionStorage.getItem('cart'))
    }

    for (var i = 0; i < this.list.length; i++) {
      this.price += parseInt(this.list[i].price)
    }
  },
  mounted () {
  },
  methods: {
    onSubmit () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 500
      })
      this.$store.dispatch('cart/initState')
      this.$store.dispatch('checkout/initState')
      this.$store.dispatch('checkout/insertState', this.list)
      console.log(this.list)
      this.$router.push({path: '/checkout'})
    },
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    onDelete (index, uid) {
      Dialog.confirm({
        title: '通知',
        message: '商品將徹底刪除，確定刪除該商品嗎?',
        confirmButtonText: '確認',
        confirmButtonColor: 'red'
      })
        .then(() => {
          this.list.splice(index, 1)
          this.$store.dispatch('cart/removeState', uid)
          Notify({ type: 'success', message: '刪除商品成功' })
        })
        .catch(() => {
          // on cancel
        })
    },
    getRecommendInfo () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getItemRecommend({ code: '', nums: 12 }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.push({ path: '/' + link })
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
  .action-bar {
    position: fixed;
    bottom:0px;
    left:auto;
    max-width:640px;
    margin:0 auto;
    z-index:1000;
  }
  .action-button {
    color: #FFFFFF;
    background-color:rgb(53, 120, 229);
    width: 40%;
  }
  .recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue